import { ModelBase } from "../shared/model.base";
import { GrupoDTO } from "./grupoDTO.type";

export class MiembroCsvDTO extends ModelBase {
    groups: GrupoDTO;
    file: any;

    constructor() {
        super();

        this.file = null;
    }
}
